import { render, staticRenderFns } from "./BusinessCardFront.vue?vue&type=template&id=779f0372&scoped=true"
import script from "./BusinessCardFront.vue?vue&type=script&lang=js"
export * from "./BusinessCardFront.vue?vue&type=script&lang=js"
import style0 from "./BusinessCardFront.vue?vue&type=style&index=0&id=779f0372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779f0372",
  null
  
)

export default component.exports